'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosSpeedometer = function IoIosSpeedometer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.1 21.8v1.2h2.3c-0.1 1.7-0.4 3.4-1.2 5-0.6 1.5-1.4 2.8-2.5 4-3-2.9-7-4.6-11.2-4.6s-8.2 1.7-11.3 4.6c-1-1.2-1.8-2.5-2.5-4-0.7-1.6-1-3.3-1.1-5h2.2v-1.3h-2.2c0.1-1.8 0.4-3.5 1.2-5.1 0.7-1.6 1.5-3 2.7-4.3l1.9 1.9 0.9-0.8-2-2c1.3-1.2 2.9-2 4.4-2.7 1.7-0.7 3.4-1.1 5.2-1.2v2.7h1.1v-2.7c1.8 0.1 3.6 0.5 5.3 1.2s3 1.5 4.3 2.7l-1.9 2 0.9 0.8 1.9-1.9c1.2 1.2 2 2.7 2.7 4.3 0.8 1.6 1.1 3.3 1.2 5.1h-2.3v0.1z m-8.8 0.7c0-0.8-0.3-1.6-0.8-2.2l5-5.9-0.2-0.1-5.7 5.1c-0.6-0.4-1.3-0.7-2.1-0.7-2 0-3.8 1.8-3.8 3.8 0 0.8 0.3 1.6 0.8 2.2l-1 0.9 0.9 0.9 1-1c0.6 0.4 1.3 0.7 2.1 0.7 2 0 3.8-1.7 3.8-3.7z m-3.8-17.5c9.7 0 17.5 7.8 17.5 17.5 0 4.5-1.6 8.4-4.4 11.6-0.3 0.3-0.5 0.6-0.8 0.9h-1.8c-2.5-3-6.3-5-10.5-5s-8 2-10.5 5h-1.8c-0.3-0.3-0.5-0.6-0.8-0.9-2.8-3.2-4.4-7.1-4.4-11.6 0-9.7 7.8-17.5 17.5-17.5z m12.1 27.9c2.7-2.9 4.1-6.7 4.1-10.6 0-4.3-1.7-8.3-4.8-11.4s-7.1-4.6-11.4-4.6-8.4 1.6-11.4 4.6-4.8 7.1-4.8 11.4c0 3.9 1.4 7.7 4.1 10.6l0.9 0.9v-0.1l0.7-0.8c1.4-1.3 3-2.4 4.7-3.1 1.9-0.7 3.8-1.1 5.8-1.1s3.9 0.4 5.8 1.1c1.7 0.7 3.3 1.8 4.7 3.1l0.8 0.8v0.1l0-0.1z m-14.6-10.4c0-1.6 0.9-2.5 2.5-2.5s2.5 0.9 2.5 2.5-0.9 2.5-2.5 2.5-2.5-0.9-2.5-2.5z' })
        )
    );
};

exports.default = IoIosSpeedometer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-speedometer.js
// module id = 2317
// module chunks = 0